import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {AttachmentService} from "@app/shared/components/attachments/attachment.service";
import {HttpUtilityService} from "@app/shared/services/api/http-utility-service";
import {TicketAttachment, TicketAttachmentImpl} from "@app/shared/services/api/tickets/tickets.interface";
import {ClassConstructor, ClassTransformer} from "class-transformer";
import {AttachmentUploadUrl as TicketAttachmentUploadUrl} from '@shared/services/api/tickets/tickets.interface';
import VariableOptions from "gql-query-builder/build/VariableOptions";
import {Observable} from "rxjs";
import {TicketsService} from "@app/shared/services";


export interface AssociateAttachmentRequestBody {
  ticket_id: string;
  attachments: {
      url: string;
      file_name: string;
  }[];
}


@Injectable({providedIn: 'root'})
export class TicketAttachmentService extends AttachmentService<TicketAttachment, string, TicketAttachmentUploadUrl, AssociateAttachmentRequestBody> {
  protected readonly recordPath = '/tickets/tickets';
  protected readonly attachmentIdKey: keyof TicketAttachment = 'attachment_id';
  protected readonly uploadUrlKey: keyof TicketAttachmentUploadUrl = 'upload_url';
  protected readonly recordIdKey: keyof TicketAttachment = 'ticket_id';
  protected readonly linkExpirationKey: keyof TicketAttachment['link'] = 'expiration_ts';
  protected readonly implementationClass: ClassConstructor<TicketAttachment> = TicketAttachmentImpl;
  /** There is currently no way to fetch attachment directly so unused for now */
  protected attachmentDataKey: string = null;
  /** There is currently no way to fetch attachment directly so unused for now */
  protected graphqlVariableOption: VariableOptions = null;
  /** There is currently no way to fetch attachment directly so unused for now */
  protected graphql = this.httpUtilityService.ticketsGraphQL.bind(this.httpUtilityService);

  constructor(http: HttpClient,
              httpUtilityService: HttpUtilityService,
              classTransformer: ClassTransformer,
              private ticketsService: TicketsService) {
    super(http, httpUtilityService, classTransformer);
  }

  /** There is currently no way to fetch attachment directly. Using method from ticketsService for now. */
  getAllAttachments(ticketId: string): Observable<TicketAttachment[]> {
    return this.ticketsService.getAttachmentsForTicket(ticketId);
  }

  buildAssociateAttachmentRequestBody(attachmentUrls: TicketAttachmentUploadUrl[], ticketId: string): AssociateAttachmentRequestBody {
    return {
      ticket_id: ticketId,
      attachments: attachmentUrls.map(attachmentUrl => ({
        url: attachmentUrl.upload_url,
        file_name: attachmentUrl.file_name
      }))
    };
  }

  extractAssociateResponseAttachments(response: Object): TicketAttachment[] {
    const attachments: TicketAttachment[] = this.httpUtilityService.extractResponseData<{attachments: TicketAttachment[]}>(response, 'ticket')['attachments'];
    return this.classTransformer.plainToInstance(TicketAttachmentImpl, attachments);
  }

  getAttachmentId(attachment: TicketAttachment): string {
    return attachment.attachment_id;
  }
}
